import script from "./LayoutFooter.vue?vue&type=script&setup=true&lang=ts&name=LayoutFooter"
export * from "./LayoutFooter.vue?vue&type=script&setup=true&lang=ts&name=LayoutFooter"

import "./LayoutFooter.vue?vue&type=style&index=0&id=3cddd2e2&lang=less"

const __exports__ = script;

export default __exports__